import React from 'react';
import EntityListFetcher from '../components/EntityListFetcher';
import { CompanyGroupListQuery } from '../graphql/query/CompanyGroupListQuery';
import typeIntro from '../static/introspection/CompanyGroup.json';
import CompanyGroupFilters from '../static/introspection/CompanyGroupFilterInput.json';
import { ENTITY } from '../utils/entities';
import { UserData } from '@food/auth';

export const CompanyGroupList = () => (
	<UserData>
		{({ isInternal }) => (
			<EntityListFetcher
				query={CompanyGroupListQuery}
				entityName={ENTITY.COMPANY_GROUP}
				headers={['name', 'type']}
				sortables={['name', 'type']}
				typeIntro={typeIntro}
				filtersIntro={CompanyGroupFilters}
				filterFields={
					isInternal
						? ['name', 'producerChangedAfter', 'types', 'Country']
						: null
				}
			/>
		)}
	</UserData>
);
